function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 15h12a1 1 0 1 1 0 2H17v12a1 1 0 1 1-2 0V17H3a1 1 0 1 1 0-2h12V3a1 1 0 1 1 2 0v12z"
});

var SvgPlus = function SvgPlus(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "afa30fdbfd8b211d4ecbac2a05952346.svg";
export { SvgPlus as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/plus.svg
// module id = null
// module chunks = 